import { Link } from 'react-router-dom'

interface VKLogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export default function VKLogo({ className = '', size = 'md' }: VKLogoProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  }

  return (
    <Link
      to="/"
      className={`inline-flex items-center justify-center rounded-full hover:scale-105 transition-transform duration-200 ${sizeClasses[size]} ${className}`}
    >
      <img src="/media/logo/vk-logo.png" alt="VK" className="w-full h-full rounded-full object-cover" />
    </Link>
  )
}
